/* Boboné — two-way variant availability.
   Shopify only cascades option availability left→right: a later option gets
   crossed out for the selected earlier options, but an earlier option is
   never crossed out for a later selection (so a sold-out/nonexistent size
   was never marked when it was the FIRST option). This recomputes every
   option value against ALL other currently-selected values and toggles the
   `disabled` class our CSS already styles (hatched size pill / slashed color
   swatch) — in both directions, including the currently-selected invalid combo. */
(function () {
  function norm(v) {
    return v == null ? '' : String(v).trim();
  }

  function variantsFor(vs) {
    var el = vs.querySelector('[data-bobone-variant-availability]');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  // Group option radios by their 1-based option position (name = "Name-<pos>").
  function optionGroups(vs) {
    var groups = {};
    vs.querySelectorAll('input[type="radio"]').forEach(function (input) {
      var name = input.name || '';
      var pos = parseInt(name.slice(name.lastIndexOf('-') + 1), 10);
      if (!pos) return;
      (groups[pos] = groups[pos] || []).push(input);
    });
    return groups;
  }

  function selectedValues(groups) {
    var sel = {};
    Object.keys(groups).forEach(function (pos) {
      var checked = groups[pos].filter(function (i) { return i.checked; })[0];
      sel[pos] = checked ? norm(checked.value) : null;
    });
    return sel;
  }

  // Is there an in-stock variant with `value` at `pos` AND every other
  // currently-selected option value matching?
  function hasAvailable(variants, pos, value, sel) {
    return variants.some(function (variant) {
      if (!variant.a) return false;
      if (norm(variant.o[pos - 1]) !== value) return false;
      for (var q in sel) {
        if (+q === pos || sel[q] == null) continue;
        if (norm(variant.o[q - 1]) !== sel[q]) return false;
      }
      return true;
    });
  }

  function recompute(vs) {
    var variants = variantsFor(vs);
    if (!variants) return;
    var groups = optionGroups(vs);
    var sel = selectedValues(groups);
    Object.keys(groups).forEach(function (pos) {
      groups[pos].forEach(function (input) {
        var ok = hasAvailable(variants, +pos, norm(input.value), sel);
        input.classList.toggle('disabled', !ok);
      });
    });
  }

  // Find the single variant whose option values match every currently-selected
  // option. With all options chosen (one radio checked per group) this is unique.
  function selectedVariant(variants, sel) {
    return variants.filter(function (variant) {
      for (var q in sel) {
        if (sel[q] == null) continue;
        if (norm(variant.o[q - 1]) !== sel[q]) return false;
      }
      return true;
    })[0] || null;
  }

  // Instant, network-free variant resolution: the moment an option changes,
  // set the form's variant id and re-enable/disable Add-to-cart from the
  // on-page data — so the button doesn't stay disabled through Dawn's section
  // fetch (the cause of the "click Agregar twice after changing size" lag).
  // Dawn's own fetch still runs afterwards and re-affirms the same state.
  // Reuses Dawn's product-form methods; if the form isn't found it no-ops
  // (falls back to Dawn's default behaviour — never worse than today).
  function applyInstantVariant(vs) {
    var variants = variantsFor(vs);
    if (!variants) return;
    var pf = document.querySelector('product-form[data-section-id="' + vs.dataset.section + '"]');
    if (!pf || typeof pf.toggleSubmitButton !== 'function') return;

    var sel = selectedValues(optionGroups(vs));
    var variant = selectedVariant(variants, sel);
    var strings = window.variantStrings || {};
    var idInput = pf.querySelector('input[name="id"]');

    if (variant) {
      if (idInput) {
        idInput.value = variant.id;
        idInput.disabled = false;
      }
      if (variant.a) {
        pf.toggleSubmitButton(false);
      } else {
        pf.toggleSubmitButton(true, strings.soldOut);
      }
    } else {
      // Non-existent option combination.
      pf.toggleSubmitButton(true, strings.unavailable);
    }
  }

  function recomputeAll(root) {
    (root && root.querySelectorAll ? root : document)
      .querySelectorAll('variant-selects')
      .forEach(recompute);
  }

  if (document.readyState !== 'loading') recomputeAll();
  else document.addEventListener('DOMContentLoaded', function () { recomputeAll(); });

  document.addEventListener('shopify:section:load', function (e) { recomputeAll(e.target); });

  // Instant feedback the moment a shopper changes an option (delegated so it
  // survives Dawn replacing the picker DOM on the server round-trip).
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (input && input.matches && input.matches('variant-selects input[type="radio"]')) {
      var vs = input.closest('variant-selects');
      if (vs) {
        recompute(vs);
        applyInstantVariant(vs);
      }
    }
  });

  // Re-apply after Dawn re-renders the picker from the server (its fresh HTML
  // carries only Shopify's one-way cascade; we re-impose the two-way result).
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, function () {
      requestAnimationFrame(function () { recomputeAll(); });
    });
  }
})();
